// this file is auto-generated via GenerateViewsFile.php 
window.viewFunctions = {};
window.viewFunctions['js/view/ASMR/ASMR.js'] = (...args) => {
	import('./ASMR/ASMR.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Actor/LandingPageHeader.js'] = (...args) => {
	import('./Actor/LandingPageHeader.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Actor/LandingPageVideosTile.js'] = (...args) => {
	import('./Actor/LandingPageVideosTile.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Actor/LandingPageRestrictedArea.js'] = (...args) => {
	import('./Actor/LandingPageRestrictedArea.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Actor/ProfileHeaderButtons.js'] = (...args) => {
	import('./Actor/ProfileHeaderButtons.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Actor/ActorProfile.js'] = (...args) => {
	import('./Actor/ActorProfile.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Cams.js'] = (...args) => {
	import('./Cams.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/ActorSearchCategories.js'] = (...args) => {
	import('./ActorSearchCategories.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/ActorSearchNavigation.js'] = (...args) => {
	import('./ActorSearchNavigation.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/ActorSearchFilter.js'] = (...args) => {
	import('./ActorSearchFilter.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/ActorSearchFilterZip.js'] = (...args) => {
	import('./ActorSearchFilterZip.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/ActorSearchResults.js'] = (...args) => {
	import('./ActorSearchResults.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/ActorSearchResultsHeader.js'] = (...args) => {
	import('./ActorSearchResultsHeader.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Cams/NewGirls.js'] = (...args) => {
	import('./Cams/NewGirls.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/MyVisitX/MyVisitXSorter.js'] = (...args) => {
	import('./MyVisitX/MyVisitXSorter.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Categories/CategoriesCamsNextDoor.js'] = (...args) => {
	import('./Categories/CategoriesCamsNextDoor.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Categories/CategoriesHeader.js'] = (...args) => {
	import('./Categories/CategoriesHeader.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Categories/CategoriesOverview.js'] = (...args) => {
	import('./Categories/CategoriesOverview.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Categories/CategoriesTopCams.js'] = (...args) => {
	import('./Categories/CategoriesTopCams.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/CookieConsent.js'] = (...args) => {
	import('./CookieConsent.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/ContestGrid.js'] = (...args) => {
	import('./ContestGrid.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/ContestVoteCount.js'] = (...args) => {
	import('./ContestVoteCount.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Conversion.js'] = (...args) => {
	import('./Conversion.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/ContestOverview.js'] = (...args) => {
	import('./ContestOverview.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/ContestDetails.js'] = (...args) => {
	import('./ContestDetails.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/DataProtection.js'] = (...args) => {
	import('./DataProtection.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/DataProtectionBar.js'] = (...args) => {
	import('./DataProtectionBar.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/IndexFooter.js'] = (...args) => {
	import('./IndexFooter.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/IndexNavbar.js'] = (...args) => {
	import('./IndexNavbar.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/IndexNavbarMenus.js'] = (...args) => {
	import('./IndexNavbarMenus.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/IndexMessenger.js'] = (...args) => {
	import('./IndexMessenger.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/IndexMessengerClick.js'] = (...args) => {
	import('./IndexMessengerClick.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Loader/Loader.js'] = (...args) => {
	import('./Loader/Loader.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Messenger.js'] = (...args) => {
	import('./Messenger.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/ModalPornmeConversion.js'] = (...args) => {
	import('./ModalPornmeConversion.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/ModalPornmeMigration.js'] = (...args) => {
	import('./ModalPornmeMigration.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/MyVisitX/FavoriteHeader.js'] = (...args) => {
	import('./MyVisitX/FavoriteHeader.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/MyVisitX/GuestProfile.js'] = (...args) => {
	import('./MyVisitX/GuestProfile.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/MyVisitX/Benefits.js'] = (...args) => {
	import('./MyVisitX/Benefits.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/MyVisitX/Spinwheel.js'] = (...args) => {
	import('./MyVisitX/Spinwheel.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/MyVisitX/Mediathek.js'] = (...args) => {
	import('./MyVisitX/Mediathek.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/MyVisitX/MyVideoChats.js'] = (...args) => {
	import('./MyVisitX/MyVideoChats.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/NavBarHelper.js'] = (...args) => {
	import('./NavBarHelper.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/NavBar.js'] = (...args) => {
	import('./NavBar.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/NewsletterUnsubscribe.js'] = (...args) => {
	import('./NewsletterUnsubscribe.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/PjaxBase.js'] = (...args) => {
	import('./PjaxBase.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Plain.js'] = (...args) => {
	import('./Plain.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Restricted.js'] = (...args) => {
	import('./Restricted.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/Goldrush.js'] = (...args) => {
	import('./Special/Goldrush.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/AdventCalendar/AdventCalendar.js'] = (...args) => {
	import('./Special/AdventCalendar/AdventCalendar.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/TwentyFiveYears.js'] = (...args) => {
	import('./Special/TwentyFiveYears.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/CumOn.js'] = (...args) => {
	import('./Special/CumOn.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/VXCalendar/VXCalendar.js'] = (...args) => {
	import('./Special/VXCalendar/VXCalendar.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/Easter/Easter.js'] = (...args) => {
	import('./Special/Easter/Easter.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/KickIt2024.js'] = (...args) => {
	import('./Special/KickIt2024.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/LateNight.js'] = (...args) => {
	import('./Special/LateNight.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/Lexy360.js'] = (...args) => {
	import('./Special/Lexy360.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/RoxxRacing.js'] = (...args) => {
	import('./Special/RoxxRacing.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/SlotMachine.js'] = (...args) => {
	import('./Special/SlotMachine.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/WiesnShooting.js'] = (...args) => {
	import('./Special/WiesnShooting.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/WetAndWild.js'] = (...args) => {
	import('./Special/WetAndWild.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/WiesnBude.js'] = (...args) => {
	import('./Special/WiesnBude.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/VRPorn.js'] = (...args) => {
	import('./Special/VRPorn.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Special/VXBirthday18.js'] = (...args) => {
	import('./Special/VXBirthday18.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Magazine/Magazines.js'] = (...args) => {
	import('./Magazine/Magazines.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Magazine/MagazinesDetails.js'] = (...args) => {
	import('./Magazine/MagazinesDetails.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Magazine/V2/Home.js'] = (...args) => {
	import('./Magazine/V2/Home.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Magazine/V2/Archives.js'] = (...args) => {
	import('./Magazine/V2/Archives.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/StatusBar.js'] = (...args) => {
	import('./StatusBar.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/CookieBlockedBar.js'] = (...args) => {
	import('./CookieBlockedBar.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/SupportChat.js'] = (...args) => {
	import('./SupportChat.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Survey.js'] = (...args) => {
	import('./Survey.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Teaser.js'] = (...args) => {
	import('./Teaser.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Test/TestPLA.js'] = (...args) => {
	import('./Test/TestPLA.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Test/TestNR.js'] = (...args) => {
	import('./Test/TestNR.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Test/TestVXPay.js'] = (...args) => {
	import('./Test/TestVXPay.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Test/TestWebPush.js'] = (...args) => {
	import('./Test/TestWebPush.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Test/TestBonus365.js'] = (...args) => {
	import('./Test/TestBonus365.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/SimpleElements/TextchatButton.js'] = (...args) => {
	import('./SimpleElements/TextchatButton.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Test/VXTeaserPreview.js'] = (...args) => {
	import('./Test/VXTeaserPreview.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/TileGrid.js'] = (...args) => {
	import('./TileGrid.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/TV/Livestream.js'] = (...args) => {
	import('./TV/Livestream.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/TV/TVPlayer.js'] = (...args) => {
	import('./TV/TVPlayer.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/TV/MediaSingle.js'] = (...args) => {
	import('./TV/MediaSingle.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/TV/SuggestVideo.js'] = (...args) => {
	import('./TV/SuggestVideo.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/SocialShareBar.js'] = (...args) => {
	import('./SocialShareBar.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/TV/MediaViewer.js'] = (...args) => {
	import('./TV/MediaViewer.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/TV/TVPremiumPricetable.js'] = (...args) => {
	import('./TV/TVPremiumPricetable.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/TV/Program.js'] = (...args) => {
	import('./TV/Program.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/TV/LateNight.js'] = (...args) => {
	import('./TV/LateNight.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/TV/VXPayHooks.js'] = (...args) => {
	import('./TV/VXPayHooks.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/SimpleElements/VideochatButton.js'] = (...args) => {
	import('./SimpleElements/VideochatButton.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/SimpleElements/VXButton.js'] = (...args) => {
	import('./SimpleElements/VXButton.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/WelcomeBanner.js'] = (...args) => {
	import('./WelcomeBanner.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/SimpleElements/VideochatMessengerButton.js'] = (...args) => {
	import('./SimpleElements/VideochatMessengerButton.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Magazine/V2/BlogArticle.js'] = (...args) => {
	import('./Magazine/V2/BlogArticle.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/WebPushSubscribe.js'] = (...args) => {
	import('./WebPushSubscribe.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/LangRedirectPopup.js'] = (...args) => {
	import('./LangRedirectPopup.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Video/IndexVideo.js'] = (...args) => {
	import('./Video/IndexVideo.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Video/VideoTrends.js'] = (...args) => {
	import('./Video/VideoTrends.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Video/VideoSub.js'] = (...args) => {
	import('./Video/VideoSub.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Video/VideoSearch.js'] = (...args) => {
	import('./Video/VideoSearch.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Video/VideoStarItems.js'] = (...args) => {
	import('./Video/VideoStarItems.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Video/VideoStars.js'] = (...args) => {
	import('./Video/VideoStars.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Banner.js'] = (...args) => {
	import('./Banner.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Homepage/IndexHomepage.js'] = (...args) => {
	import('./Homepage/IndexHomepage.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/NotFound.js'] = (...args) => {
	import('./NotFound.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Search.js'] = (...args) => {
	import('./Search.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/SearchResults.js'] = (...args) => {
	import('./SearchResults.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/DailyBonus/DailyBonusIndex.js'] = (...args) => {
	import('./DailyBonus/DailyBonusIndex.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Vx20Years/Vx20Years.js'] = (...args) => {
	import('./Vx20Years/Vx20Years.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/FreeChat.js'] = (...args) => {
	import('./FreeChat.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Lindemann.js'] = (...args) => {
	import('./Lindemann.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/VIPClub.js'] = (...args) => {
	import('./VIPClub.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/VIP30.js'] = (...args) => {
	import('./VIP30.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/ClashOfCams.js'] = (...args) => {
	import('./ClashOfCams.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/UserActivities.js'] = (...args) => {
	import('./UserActivities.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/VXSelect/IndexVXSelect.js'] = (...args) => {
	import('./VXSelect/IndexVXSelect.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/VIP30Badge.js'] = (...args) => {
	import('./VIP30Badge.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Welcome.js'] = (...args) => {
	import('./Welcome.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/CamShows.js'] = (...args) => {
	import('./CamShows.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/TermsOfService.js'] = (...args) => {
	import('./TermsOfService.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Imprint.js'] = (...args) => {
	import('./Imprint.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Feed.js'] = (...args) => {
	import('./Feed.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/FloatingNotifications.js'] = (...args) => {
	import('./FloatingNotifications.js').then((view) => view.run(...args));
};
window.viewFunctions['js/view/Showcase.js'] = (...args) => {
	import('./Showcase.js').then((view) => view.run(...args));
};
